import { EVENT_CLOSE } from '../modal'
import { WEB_PUSH_MODAL_NAME } from './webPush.vars'
import { ModalExternalService } from '@/src/shared/lib/modal'
import { eventBus } from '@/src/shared/lib/eventBus'

export default class WebPushModalService extends ModalExternalService {
  constructor() {
    super(WEB_PUSH_MODAL_NAME, eventBus)
  }

  public open() {
    super.open()
  }

  public close() {
    super.close()
  }

  public actionOnClose(callback: Function) {
    this.actionOn(EVENT_CLOSE, callback)
  }

  public actionOffClose(callback: Function) {
    this.actionOff(EVENT_CLOSE, callback)
  }
}

export const webPushModalService = new WebPushModalService()
